import { DecimalPipe } from "@angular/common";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { MenuCategoriesModalComponent } from "src/app/shared/components/menu-categories-modal/menu-categories-modal.component";
import { NgbdSortableHeader } from "src/app/shared/directives/NgbdSortableHeader";
import { AccountService } from "src/app/shared/service/account.service";
import { CategoryService } from "src/app/shared/service/category.service";
import { TableService } from "src/app/shared/service/table.service";
import { CategoryRequestModel } from "src/app/shared/tables/catergory-request";

@Component({
  selector: "app-menu-categories-list",
  templateUrl: "./menu-categories-list.component.html",
  styleUrls: ["./menu-categories-list.component.scss"],
  providers: [TableService, DecimalPipe],
})
export class MenuCategoriesListComponent {
  searchText;
  tableItem$: Observable<any[]>;
  total$: Observable<number>;
  categoryToDelete$: Observable<CategoryRequestModel> =
    new Observable<CategoryRequestModel>();
  restuarantId$: Observable<string>;
  restuarantId: string = "";
  public restuarants$: Observable<any[]>;

  public selectedId: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild("menuCategoriesModal")
  private modalComponent!: MenuCategoriesModalComponent;

  selectedCategoryId: string;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    public categoryService: CategoryService,
    private sanitizer: DomSanitizer,
    private accountService: AccountService
  ) {
    const user = this.accountService.getLoggedInUser();
    this.restuarantId = user.restaurantId;
    this.tableItem$ = this.categoryService.getCategoriesForRestaurant(
      user.restaurantId,
      1,
      10
    );
    this.total$ = this.categoryService.total$;
    this.restuarants$ = categoryService.getAllRestuarants();

    // this.menuItemService.setUserData(CATEGORY)
  }

  selectRestuarant(event: any) {
    console.log(event);
    this.categoryService.setRestuarantId(event);
  }

  editCategory(selectedId: string) {
    this.selectedCategoryId = selectedId;
    this.selectedId.emit(selectedId);
    this.modalComponent.open();
  }

  deleteCategory(categoryId: string) {
    this.categoryToDelete$ = this.categoryService.getCategoryById(categoryId);
    this.categoryToDelete$.subscribe((c) =>
      this.categoryService.deleteCategory(c).subscribe()
    );
  }

  handlePageEvent(e: PageEvent) {
    console.log(e);
    this.tableItem$ = this.categoryService.getCategoriesForRestaurant(
      this.restuarantId,
      e.pageIndex + 1,
      e.pageSize
    );
  }
}
